"use client";
import { classes } from "@/classnames";
import { Modal } from "@/components/ui/modal";
import { SelectOption } from "@/components/ui/select/select.types";
import { SubmitButton } from "@/components/ui/submit-button";
import { postJoinUsForm } from "@/features";
import { useLoading } from "@/hooks/use-loading";
import { useModal } from "@/hooks/use-modal";
import { CareerFormData } from "@/types/forms";
import { getSelectOptions } from "@/utils";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitHandler, useForm } from "react-hook-form";
import { SingleValue } from "react-select";
import { FileInput, Input, Select } from "../../ui";
import { FormWrapper } from "../form-wrapper";
import { IJoinOurTeam } from "./join-our-team.types";
import { careerFormValidationSchema } from "./join-our-team.validate";
import { useState } from "react";

export const JoinOurTeam: IJoinOurTeam = ({ vacancies }) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    resetField,
    clearErrors,
    formState: { errors },
  } = useForm<CareerFormData>({
    resolver: yupResolver(careerFormValidationSchema as any),
    mode: "onTouched",
  });
  const [isInputNeededClear, setIsInputNeededClear] = useState(false);

  const { loading, setLoading } = useLoading();

  const { isVisible, hide, open } = useModal();

  const onSubmit: SubmitHandler<CareerFormData> = async (data) => {
    setLoading(true);
    const response = await postJoinUsForm(data);
    setLoading(false);

    if (!response.error) {
      reset();
      setIsInputNeededClear(true);
      resetField("name");
      open();
    }
  };

  const options = getSelectOptions(vacancies);

  const vacancy_id = getValues().vacancy_id;

  const value = options.find((el) => el.value === vacancy_id);

  const onSelect = (value: SingleValue<SelectOption>) => {
    const newValue = value?.value;
    newValue ? setValue("vacancy_id", newValue as number) : resetField("vacancy_id");
    clearErrors("vacancy_id");
  };

  return (
    <FormWrapper title="Join our team">
      <form
        autoComplete={"off"}
        className={classes.Form}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Input
          className={classes.FormItem}
          {...register("name")}
          required
          label="NAME"
          error={errors.name?.message}
        />

        <Input
          className={classes.FormItem}
          type="email"
          {...register("email")}
          required
          label="email"
          error={errors.email?.message}
        />

        <Select
          onSelect={onSelect}
          value={value}
          options={options}
          label="select a position"
          error={errors.vacancy_id?.message}
        />

        <Input
          className={classes.FormItem}
          {...register("portfolio_link")}
          label="portfolio link"
          error={errors.portfolio_link?.message}
        />

        <FileInput
          type="file"
          {...register("file")}
          label="Attach a CV"
          required
          error={errors.file?.message}
          isInputNeededClear={isInputNeededClear}
          setIsInputNeededClear={setIsInputNeededClear}
        />

        <Input
          label="telegram link"
          {...register("telegram_link")}
          required
          error={errors.telegram_link?.message}
        />
        <SubmitButton loading={loading} />
      </form>
      <Modal
        isVisible={isVisible}
        hide={hide}
      >
        <h5 className="text-[40px] font-[600] leading-[120%] uppercase text-white text-center">
          The Message Was Sent Successfully
        </h5>
        <p className="text-[20px] font-[600] text-text-04 text-center">
          Thank you for getting in touch! We appreciate your interest. Our team will review your message and get back to
          you shortly
        </p>
      </Modal>
    </FormWrapper>
  );
};
